"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _GradientButton = _interopRequireDefault(require("./../buttons/GradientButton"));
var _Button = _interopRequireDefault(require("./../buttons/Button"));
var _TabNavigationModule = _interopRequireDefault(require("./../../scss/navigations/TabNavigation.module.scss"));
require("./../../scss/navigations/TabNavigation.css");
function TabNavigation(_ref) {
  let {
    tabs = [],
    onTabChanged = () => true,
    children
  } = _ref;
  const [currentTab, setCurrentTab] = (0, _react.useState)(tabs[0]);
  const handleClick = tab => {
    // reset grid state with vanilla js in order for 
    // animation to run react doesn't re-render the 
    // basic-grid-module if it's present on both tabs
    const basicGridEl = document.querySelector('basic-grid-module');
    basicGridEl === null || basicGridEl === void 0 || basicGridEl.setAttribute('first-entry', true);
    basicGridEl === null || basicGridEl === void 0 || basicGridEl.setAttribute('data-state', 'entering');
    if (tab.button.label !== currentTab.button.label) setCurrentTab(tab);
  };
  (0, _react.useEffect)(() => onTabChanged(currentTab), [currentTab, onTabChanged]);
  return /*#__PURE__*/_react.default.createElement("tab-navigation", null, /*#__PURE__*/_react.default.createElement("ul", {
    className: [_TabNavigationModule.default['tab-navigation__list'], 'tab-navigation__list'].join(' ')
  }, tabs.length && tabs.map((tab, index) => {
    if (currentTab.button.label === tab.button.label) {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: [_TabNavigationModule.default['tab-navigation__item'], 'tab-navigation__item'].join(' '),
        key: "tab-item-".concat(tab.button.label),
        style: {
          '--gradient-start-color': tab.button.gradientStartColor,
          '--gradient-end-color': tab.button.gradientEndColor
        }
      }, /*#__PURE__*/_react.default.createElement(_GradientButton.default, {
        onClick: e => {
          handleClick(tab);
        },
        label: tab.button.label,
        disabled: true
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: [_TabNavigationModule.default['tab-navigation__item'], 'tab-navigation__item'].join(' '),
        key: "tab-item-".concat(tab.button.label)
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: e => {
          handleClick(tab);
        },
        label: tab.button.label,
        customColors: {
          bgColor: tab.button.buttonBgColor,
          bgHoverColor: tab.button.buttonHoverBgColor,
          color: tab.button.buttonTextColor,
          hoverColor: tab.buttonHoverTextColor,
          borderColor: tab.button.buttonTextColor,
          borderHoverColor: tab.button.buttonHoverBgColor
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabNavigationModule.default['tab-navigation__right-side']
  }, children !== undefined && children));
}
var _default = exports.default = TabNavigation;